var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "mint-toast-pop" } }, [
    _vm.show
      ? _c("div", { class: "mint-toast " + _vm.customClass }, [
          _c("span", { staticClass: "line" }),
          _vm._v(_vm._s(_vm.message) + "\n    ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }